const scriptPromises = new Map();

export const loadScript = (src, targetDocument = document) => {
  if (!targetDocument) {
    return Promise.reject(new Error('当前环境不支持加载脚本'));
  }
  if (scriptPromises.has(src)) {
    return scriptPromises.get(src);
  }
  const existingScript = targetDocument.querySelector?.(`script[src="${src}"]`);
  if (existingScript) {
    return Promise.resolve(existingScript);
  }

  const promise = new Promise((resolve, reject) => {
    const script = targetDocument.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => {
      resolve(script);
    };
    script.onerror = () => {
      scriptPromises.delete(src);
      reject(new Error('飞书 SDK 加载失败'));
    };
    targetDocument.head.appendChild(script);
  });

  scriptPromises.set(src, promise);
  return promise;
};
